import { useEffect } from 'react';
import { registerSiteTools } from './registration';

/** Mount once outside route-level content. Unsupported browsers see no change. */
export default function SiteTools() {
  useEffect(() => registerSiteTools(), []);
  return null;
}
